module.exports = __webpack_public_path__ + "8d41969db75e3c5e42e3dde3db6dd7ea.svg";